import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@mui/material';
import { useState } from 'react';
import type { SubmitHandler } from 'react-hook-form';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { useAuth } from '../../shared/hooks/useAuth';
import { config } from '../../shared/config';

import type { ForgotPayload } from '../../types';
import Input from './Input';
import { buildYupLocale } from './buildYupLocale';
import InputWrapper from './InputWrapper';
import Message from './Message';

type ForgotFormProps = {
  setSended: (result: boolean) => void;
};

function ForgotForm({ setSended }: ForgotFormProps) {
  const [error, setError] = useState<null | string>(null);
  const auth = useAuth();
  const { t } = useTranslation();
  buildYupLocale(t);

  const schema = yup
    .object({
      email: yup.string().email().required(),
      cf: yup
        .string()
        .matches(/[A-Z0-9]{16}/)
        .required(),
    })
    .required();

  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm<ForgotPayload>({
    resolver: yupResolver(schema),
    defaultValues: {
      email: '',
      cf: '',
    },
  });

  const onSubmitMail: SubmitHandler<ForgotPayload> = ({ email, cf }) => {
    auth?.forgot(
      { email, cf },
      () => {
        setSended(true);
      },
      (errorType) => {
        // -1 Non risultano utenti registrati con i dati indicati
        // -2 Risultano più utenti registrati con i dati indicati. Contattare l'assistenza tecnica
        // -3 Non è stata trovata una e-mail valida  per l'utente indicato
        if (errorType == -1) {
          setError(t('errors.forgot no users'));
        }
        if (errorType == -2) {
          setError(t('errors.forgot more users'));
        }
        if (errorType == -3) {
          setError(t('errors.forgot no valid email'));
        }
      },
    );
  };

  const onSubmitSms: SubmitHandler<ForgotPayload> = ({ email, cf }) => {
    auth?.forgotSms(
      { email, cf },
      () => {
        setSended(true);
      },
      () => {
        setError(t('errors.forgot no users'));
      },
    );
  };

  return (
    <>
      <form onSubmit={handleSubmit(config.forgotSmsEnabled ? onSubmitSms : onSubmitMail)}>
        <InputWrapper>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <Input
                errorFlag={Boolean(errors.email)}
                message={errors?.email?.message ?? ''}
                field={field}
                label={t('email')}
              />
            )}
          />
        </InputWrapper>
        <InputWrapper>
          <Controller
            name="cf"
            control={control}
            render={({ field }) => (
              <Input errorFlag={Boolean(errors.cf)} message={errors?.cf?.message ?? ''} field={field} label={t('cf')} />
            )}
          />
        </InputWrapper>
        <InputWrapper>
          <Button type="submit" variant="contained">
            {t('send')}
          </Button>
        </InputWrapper>
      </form>
      <InputWrapper>
        <Message error={error} />
      </InputWrapper>
    </>
  );
}

export default ForgotForm;
